import React from 'react';

const Hero: React.FC = () => {
  const scrollToMailingList = () => {
    const mailingListSection = document.getElementById('mailing-list');
    if (mailingListSection) {
      mailingListSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <section className="relative w-full h-screen overflow-hidden">
      {/* Hero Image */}
      <div 
        className="absolute inset-0 bg-gradient-to-r from-dance-navy/20 to-dance-terracotta/20"
        style={{
          backgroundImage: `url('/images/hero1.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />
      
      {/* April Event Banner - Absolutely positioned so it doesn't affect layout */}
      <div className="absolute top-4 left-0 right-0 z-20 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-dance-gold/95 to-dance-terracotta/95 backdrop-blur-sm rounded-lg p-4 shadow-xl border-2 border-white/20">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex-1 text-center sm:text-left">
                <p className="text-dance-navy font-bold text-lg md:text-xl tracking-wide">
                  Popup Event Coming in April
                </p>
                <p className="text-dance-navy/90 text-sm md:text-base mt-1">
                  Join our newsletter to be notified when details are announced
                </p>
              </div>
              <button
                onClick={scrollToMailingList}
                className="bg-dance-navy text-white px-6 py-2 text-sm md:text-base font-semibold tracking-wide hover:bg-dance-navy/90 transition-all duration-300 rounded-lg shadow-md hover:shadow-lg whitespace-nowrap"
              >
                GET NOTIFIED
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-white mb-4 sm:mb-6 tracking-wider leading-tight">
            The Dance Floor
          </h2>
          <h3 className="text-lg sm:text-2xl md:text-3xl lg:text-4xl font-sans font-light text-white/90 mb-6 sm:mb-8 tracking-widest">
            A Dancer's Home
          </h3>
          <p className="text-base sm:text-xl md:text-2xl text-white/80 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed font-light px-2">
            Austin's premier destination for ballroom, latin, and social dance
          </p>
          <button 
            onClick={() => {
              const mailingListSection = document.getElementById('mailing-list');
              if (mailingListSection) {
                mailingListSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            }}
            className="bg-dance-navy text-white px-8 sm:px-12 py-4 sm:py-5 text-base sm:text-lg font-semibold tracking-wider hover:bg-dance-terracotta transition-all duration-300 rounded-sm shadow-lg hover:shadow-xl transform hover:-translate-y-1 w-full sm:w-auto"
          >
            JOIN OUR COMMUNITY
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;

